import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_BIOMETRIA } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { ConsultarDigitaisIIRGDRequest, Types } from './types';

// ACTIONS
import {
	consultarDigitaisIIRGDClear,
	consultarDigitaisIIRGDSuccess,
	consultarDigitaisIIRGDFailure,
} from './actions';

function* consultarDigitaisIIRGDRequestTest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarDigitaisIIRGDRequest } = request;

	yield put(consultarDigitaisIIRGDClear());

	const body = {
		// cpf: payload.cpf,
		finalidade: payload.finalidade,
		rgSp: payload.rgSp,
		dataNascimento: payload.dataNascimento,
		incluirPendentes: payload.incluirPendentes,
		idAtendimento: payload.idAtendimento,
		reuso: payload.reuso,
	};

	try {
		const response: ApiResponse = yield call(
			getApi,
			token || '',
			PATH_BIOMETRIA,
			`digitais`,
			body,
		);

		if (response.status === 200) {
			yield put(consultarDigitaisIIRGDSuccess(response.data));
		} else if (
			response.data?.messages &&
			response.data.messages.includes('pessoa-desconhecida')
		) {
			yield put(consultarDigitaisIIRGDSuccess(response.data));
		} else {
			yield put(consultarDigitaisIIRGDFailure(response.data));
		}
	} catch (error) {
		yield put(
			consultarDigitaisIIRGDFailure({
				status: 500,
				data: { mensagens: ['Serviço de biometria indisponível.'] },
			}),
		);
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_DIGITAIS_IIRGD_REQUEST,
		consultarDigitaisIIRGDRequestTest,
	),
]);
